import {
  CabinetConfigurationModel,
  CabinetReferenceConfigurationModel,
  CabinetReferenceType,
  Configuration,
  EditMode,
  ReferenceConfigurationModel,
  StoreConstants
} from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { mapActions, mapGetters } from 'vuex';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';

export const CabinetConfigurationHelper = {
  methods: {
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Actions.GetChangeWithErrorPage
    ]),
    navigateToCabinetsDashboard(this: any) {
      this.$router.push({ name: Configuration.Cabinet.CabinetsDashboard.name });
    },
    navigateToCabinetDashboard(this: any, cabinetId: string) {
      this.$router.push({
        name: Configuration.Cabinet.CabinetDashboard.name,
        params: { cabinetId }
      });
    },
    navigateToDocumentTypeDashboard(this: any, cabinetId: string, documentTypeId: number) {
      this.$router.push({
        name: Configuration.Cabinet.DocumentTypeDashboard.name,
        params: { cabinetId, documentTypeId }
      });
    },
    async getLock(this: any) {
      await this.getChangeWithErrorPage();
    },
    getCabinetReferenceIndex(
      this: any,
      cabinetConfiguration: CabinetConfigurationModel,
      cabinetReferenceConfiguration: CabinetReferenceConfigurationModel,
      documentTypeId: number | null
    ) {
      return cabinetConfiguration.cabinetReferences.findIndex(
        (cabRef: CabinetReferenceConfigurationModel) =>
          cabRef.referenceType === cabinetReferenceConfiguration.referenceType &&
          cabRef.referenceNumber === cabinetReferenceConfiguration.referenceNumber &&
          cabRef.documentTypeId === documentTypeId &&
          cabRef.id === cabinetReferenceConfiguration.id
      );
    },
    findReferenceConfigurationIndexForDocumentType(
      this: any,
      cabinetConfiguration: CabinetConfigurationModel,
      documentTypeIndex: number,
      referenceType: CabinetReferenceType,
      referenceNumber: number
    ) {
      return cabinetConfiguration.documentTypes[documentTypeIndex].referencesConfiguration.findIndex(
        (refConfig: ReferenceConfigurationModel) =>
          refConfig.referenceType === referenceType && refConfig.referenceNumber === referenceNumber
      );
    },
    checkLockedForEditMode(this: any, editMode: EditMode) {
      if (editMode !== EditMode.View && !this.validLock) {
        SnotifyConfiguration.showInformation('Sorry, you must be in edit mode to make changes.');
        this.navigateToCabinetsDashboard();
      }
    },
    referencesExistWithSameDescription(
      this: any,
      cabinetReferences: CabinetReferenceConfigurationModel[],
      description: string,
      documentTypeId: number | null,
      cabinetReferenceType: CabinetReferenceType
    ) {
      return cabinetReferences.filter((x) => !x.isDeleted).some(
        (cabRef: CabinetReferenceConfigurationModel) =>
          cabRef.description.toLowerCase() === description.toLowerCase() &&
          (cabinetReferenceType === CabinetReferenceType.Common ||
            cabRef.referenceType === CabinetReferenceType.Common ||
            (cabRef.referenceType === CabinetReferenceType.Document && cabRef.documentTypeId === documentTypeId))
      );
    },
    async getAllCabinetNames(this: any) {
      try {
        this.ALL_CABINET_NAMES = await CabinetConfigurationService.getAllCabinetNames();
      } catch (error) {
        this.$log(error);
      }
    }
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationLockHeldByCurrentSession
    ]),
    validLock(this: any) {
      return this.cabinetConfigurationLockHeldByCurrentSession;
    }
  },
  created(this: any) {
    this.ALL_CABINET_NAMES = [];
  }
};
